import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import BeatLoader from 'react-spinners/BeatLoader'
import styled from 'styled-components'

import {
    IconImageOutlineCounter,
    IconPlaylistWhite,
    IconPlus,
    IconPlusInBox,
    IconVideoOutlineCounter
} from 'assets/svg/sprite'
import { Button } from 'components/Button/Button'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { Icons } from 'helpers/icons'
import { getPlaylists } from 'services/endpoints/media'
import { type IPlaylist } from 'types/interfaces/ITypes'

import styles from './addToPlaylist.module.scss'

interface Props {
    closeFn: () => void
    confirmFn: () => void
    addNew: () => void
    selectedPlaylist: string
    setSelectedPlaylist: (val: string) => void
}

interface IMediaCounter {
    photoCount?: number
    videoCount?: number
    audioCount?: number
}

const MediaCounter = ({
    photoCount,
    videoCount,
    audioCount
}: IMediaCounter) => {
    return (
        <div className={styles.counterWrapper}>
            {!!photoCount && (
                <div className={styles.info}>
                    <IconImageOutlineCounter color='#828C94' />
                    <div className={styles.count}>
                        <p>{photoCount}</p>
                    </div>
                </div>
            )}
            {!!videoCount && (
                <div className={styles.info}>
                    <IconVideoOutlineCounter color='#828C94' />
                    <div className={styles.count}>
                        <p>{videoCount}</p>
                    </div>
                </div>
            )}
            {!!audioCount && (
                <div className={styles.info}>
                    <AudioIcon src={Icons.chat_mic} />
                    <div className={styles.count}>
                        <p>{audioCount}</p>
                    </div>
                </div>
            )}
        </div>
    )
}

const Playlists = ({
    closeFn,
    confirmFn,
    addNew,
    selectedPlaylist,
    setSelectedPlaylist
}: Props) => {
    const { data, isLoading } = useQuery(
        ['getPlaylists'],
        async () => await getPlaylists(),
        {
            refetchOnWindowFocus: false,
            staleTime: 10000
        }
    )

    const { t } = useTranslation()

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.title}>{t('playlists')}</div>
                <div
                    className={styles.button}
                    onClick={() => {
                        addNew()
                    }}
                >
                    <IconPlus />
                </div>
            </div>
<div className={styles.list}>
    <div className={styles.inner}>
        {isLoading ? (
            <LoaderWrapper>
                <BeatLoader size={10} color="#999" />
            </LoaderWrapper>
        ) : (
            <>
                {data?.map((playlist: IPlaylist) => {
                    return (
                        <ActionCard
                            key={playlist.playlist_info.id}
                            icon={
                                <div className={styles.iconWrapperBlue}>
                                    <IconPlaylistWhite color='white' />
                                </div>
                            }
                            iconSize='small'
                            text={playlist.playlist_info.name}
                            subtext={
                                <MediaCounter
                                    photoCount={
                                        playlist.media_counters.photo_sum
                                    }
                                    videoCount={
                                        playlist.media_counters.video_sum
                                    }
                                    audioCount={
                                        playlist.media_counters.sound_sum
                                    }
                                />
                            }
                            hasRadio
                            toggleActive={
                                selectedPlaylist ===
                                playlist.playlist_info.id
                            }
                            clickFn={() => {
                                setSelectedPlaylist(
                                    playlist.playlist_info.id
                                )
                            }}
                        />
                    )
                })}

                <ActionCard
                    icon={<IconPlusInBox width='22' height='22' />}
                    iconSize='small'
                    text={t('addNewPlaylist')}
                    addNewText
                    clickFn={() => {
                        addNew()
                    }}
                />
            </>
        )}
    </div>
</div>
            <div className={styles.footer}>
                <Button
                    text={t('cancel')}
                    color='grey'
                    font='mont-14-normal'
                    width='11'
                    height='3'
                    clickFn={closeFn}
                />

                <Button
                    text={t('addToPlaylist')}
                    color='black'
                    font='mont-14-normal'
                    width='15'
                    height='3'
                    clickFn={() => {
                        confirmFn()
                    }}
                    disabled={!selectedPlaylist}
                />
            </div>
        </div>
    )
}

export default Playlists

const AudioIcon = styled.img`
    width: 1.2rem;
    height: 1.2rem;

`
const LoaderWrapper = styled.div`
    width: 100%;
    min-height: 16rem;
    display: flex;
    align-items: center;
    justify-content: center;
`